import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import main from './main'
import megogo from './megogo'
import youtv from './youtv'
import adminpanel from './adminpanel'

export default new Vuex.Store({
  modules: {
    main,
    megogo,
    youtv,
    adminpanel
  }
})
